import { render, staticRenderFns } from "./MaterialProjectAdd.vue?vue&type=template&id=475d4269&scoped=true"
import script from "./js/material_project_add.js?vue&type=script&lang=js&external"
export * from "./js/material_project_add.js?vue&type=script&lang=js&external"
import style0 from "./MaterialProjectAdd.vue?vue&type=style&index=0&id=475d4269&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475d4269",
  null
  
)

export default component.exports